import { OptionsObject, SnackbarKey } from 'notistack';
import { LocationState } from 'history';
import { LangValueType } from 'core/types';
import { IPhoneParams } from '../../../../redux/reducers/WPContent/type';

export interface ILayoutState {
  redirect: {
    url: string | null;
    state?: LocationState;
  };
  loading: Set<string>;
  modalLoading: Set<string>;
  isSuccess: boolean;
  message?: string | null;
  notifications: (INotificationOptions & { key: SnackbarKey })[];
  languagePath: string;
  language: LangValueType;
  withoutLanguagePath: string;
  layoutInfo: ILayoutInfo;
  alerts: Array<IAlert>;
  alertsUniversal: Array<IAlertUniversal>;
}

export interface INotificationOptions {
  message: string;
  options?: OptionsObject;
  dismissed?: boolean;
}

export interface ILayoutInfo {
  header: IHeader;
  footer: IFooter;
}

export interface IHeader {
  contacts: IContacts;
  menu: IMenuItem[];
  mobile_menu_title?: string;
  stocks_count?: number;
}

export interface IFooter {
  contacts: IContacts;
  menu: IMenuItem[];
  socials?: ISocialIcon[];
  btn_link?: string;
  btn_text?: string;
  copyright?: string;
  socials_title?: string;
  underfooter_description?: string;
  underfooter_text?: string;
  underfooter_title?: string;
}

export interface IContacts {
  email?: string;
  phone?: IPhoneParams;
  phone_text?: string;
  title?: string;
  time_footer?: string;
  schedule?: string;
}

export interface IMenuItem {
  title: string;
  url: string;
}

export interface ISocialIcon {
  icon: string;
  url: string;
}

export type IIcons = {
  [Key in LangValueType]?: JSX.Element | string | undefined;
};

export enum AlertType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export interface IAlert {
  textData: {
    message: string;
    data?: any;
    serverMessage?: string;
  };
  timeout?: number;
  type: AlertType;
  id: number;
  // new params:
  mode?: IAlertUniversalMode;
  closable?: boolean;
  auto_close_after_secs?: number;
  header?: string;
  content?: IAlertUniversalContent;
}

export enum IAlertUniversalMode {
  modal = 'modal',
  popup = 'popup',
}
export interface IAlertUniversalContent {
  text?: string;
  type?: string;
  url?: string;
  open_in_new_window?: boolean;
}

export interface IAlertUniversal {
  mode: IAlertUniversalMode;
  closable: boolean;
  auto_close_after_secs: number;
  header?: string;
  content: IAlertUniversalContent;
  // textData: {
  //   message: string;
  //   data?: any;
  //   serverMessage?: string;
  // };
  // timeout?: number;
  type: AlertType;
  id: number;
}
